import { PAGES } from '@moniebook-web/types';
import { Navigate, Outlet, type RouteObject } from 'react-router';

import { StyleScope } from '@/features/shared/style-scope';

export const authRoutes: RouteObject[] = [
    {
        path: '',
        element: <StyleScope name='auth-ui' />,
        children: [
            {
                path: '',
                async lazy() {
                    const { mainOutlet } = await unwrapFeatures();
                    return mainOutlet().then((m) => ({ Component: m.default }));
                },
                children: [
                    {
                        path: '',
                        element: <Navigate to={PAGES.AUTH_UI.LOGIN} />,
                    },
                    {
                        path: 'sign-in',
                        async lazy() {
                            const { signIn } = await unwrapFeatures();

                            return signIn().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'moniebook',
                        element: <Outlet />,
                        children: [
                            {
                                path: 'sign-in',
                                async lazy() {
                                    const { staffSignIn } =
                                        await unwrapFeatures();

                                    return staffSignIn().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'select-business',
                                async lazy() {
                                    const { selectBusiness } =
                                        await unwrapFeatures();

                                    return selectBusiness().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                        ],
                    },
                    {
                        path: 'moniepoint',
                        element: <Outlet />,
                        children: [
                            {
                                path: 'sign-in',
                                element: <Outlet />,
                                children: [
                                    {
                                        path: '',
                                        async lazy() {
                                            const { signInWithMoniepointPage } =
                                                await unwrapFeatures();

                                            return signInWithMoniepointPage().then(
                                                (m) => ({
                                                    Component: m.default,
                                                }),
                                            );
                                        },
                                    },
                                    {
                                        path: 'complete',
                                        async lazy() {
                                            const { completeMoniepointSignIn } =
                                                await unwrapFeatures();

                                            return completeMoniepointSignIn().then(
                                                (m) => ({
                                                    Component: m.default,
                                                }),
                                            );
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'forgot-username',
                                async lazy() {
                                    const { forgotUsername } =
                                        await unwrapFeatures();

                                    return forgotUsername().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                        ],
                    },
                    {
                        path: 'invalid-onboarding',
                        async lazy() {
                            const { invalidOnboarding } =
                                await unwrapFeatures();

                            return invalidOnboarding().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'incomplete-onboarding',
                        async lazy() {
                            const { incompleteOnboarding } =
                                await unwrapFeatures();

                            return incompleteOnboarding().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'create-account',
                        async lazy() {
                            const { createAccount } = await unwrapFeatures();

                            return createAccount().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'confirm-email',
                        async lazy() {
                            const { confirmEmail } = await unwrapFeatures();

                            return confirmEmail().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'invalid-invitation',
                        async lazy() {
                            const { invalidInvitation } =
                                await unwrapFeatures();

                            return invalidInvitation().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'confirm-password',
                        async lazy() {
                            const { confirmPassword } = await unwrapFeatures();

                            return confirmPassword().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'reset-password',
                        element: <Outlet />,
                        children: [
                            {
                                path: '',
                                async lazy() {
                                    const { resetPassword } =
                                        await unwrapFeatures();

                                    return resetPassword().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'invalid',
                                async lazy() {
                                    const { invalidResetLink } =
                                        await unwrapFeatures();

                                    return invalidResetLink().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'successful',
                                async lazy() {
                                    const { successfulResetLink } =
                                        await unwrapFeatures();

                                    return successfulResetLink().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                        ],
                    },
                    {
                        path: 'forgot-password',
                        element: <Outlet />,
                        children: [
                            {
                                path: '',
                                async lazy() {
                                    const { forgotPassword } =
                                        await unwrapFeatures();

                                    return forgotPassword().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'successful',
                                async lazy() {
                                    const { passwordResetSuccessful } =
                                        await unwrapFeatures();

                                    return passwordResetSuccessful().then(
                                        (m) => ({
                                            Component: m.default,
                                        }),
                                    );
                                },
                            },
                        ],
                    },
                    {
                        path: 'terms-and-conditions',
                        async lazy() {
                            const { termsAndConditions } =
                                await unwrapFeatures();

                            return termsAndConditions().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'auth/external/:tokenIdentifier',
                        async lazy() {
                            const { externalLogin } = await unwrapFeatures();

                            return externalLogin().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'auth/external-onboarding/:tokenIdentifier',
                        async lazy() {
                            const { externalOnboarding } =
                                await unwrapFeatures();

                            return externalOnboarding().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'auto-logged-out',
                        async lazy() {
                            const { autoLoggedOut } = await unwrapFeatures();

                            return autoLoggedOut().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'join',
                        async lazy() {
                            const { join } = await unwrapFeatures();

                            return join().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
            {
                path: 'implementation/:taskId/confirm-completion',
                async lazy() {
                    const { confirmImplementationCompletion } =
                        await unwrapFeatures();

                    return confirmImplementationCompletion().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
        ],
    },
];

async function unwrapFeatures() {
    const features = await import('auth/features');

    return features.default;
}
